export default "__VITE_ASSET__qrhu7nEx__"